export default "__VITE_ASSET__Tx72d2h$__"